import styled from 'styled-components'
import { VARIABLES } from 'themes'
export const LoadersStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  &.mainContainer {
    display: flex;
    align-items: center;
    margin-left: 1em;
  }
`
